import { Card, CardContent } from "@/components/ui/card";
import QuotationForm from "@/v2/components/pages/quotation/Form";
import FormPageHeading from "@/v2/components/ui/heading/FormPage";
import { ScrollTextIcon } from "lucide-react";

export default function GenerateQuotation() {
    return (
        <div className="my-3 min-h-screen">
            <Card className="rounded-xl border-slate-200 shadow-lg dark:border-slate-700">
                <FormPageHeading
                    title={"Generate Quotation"}
                    description="Enter information to generate quotation"
                    Icon={ScrollTextIcon}
                />

                <CardContent className="pt-6">
                    <QuotationForm />
                </CardContent>
            </Card>
        </div>
    );
}
